import React from 'react';
import { Button } from 'react-bootstrap';
import _ from 'lodash';

export default function CancelButton(props) {
    const cancelClicked = () => {
        if (props.clicked) { props.clicked(); }
    };

    const cancelText = !_.isEmpty(props.text) ? props.text : 'Cancel';

    return (
        <Button bsStyle="default" onClick={cancelClicked} className={props.className} disabled={props.disabled}>
            <i className="fa fa-undo button-icon"></i>
            {cancelText}
        </Button>
    );
}
